import React from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import { Container, } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
 import RentalsDrivers from "./rental-drivers-list"
//import "../../../../assets/scss/custom.scss"

const RentalDrivers = props => {
  return (
    <>
      {
        <React.Fragment>
          <div className="page-content">
            <MetaTags>
              <title>Rental Drivers | EEFind </title>
            </MetaTags>
            <Container fluid>
              <Breadcrumbs title="Rentals" breadcrumbItem="Rental Drivers" />
              <RentalsDrivers queryCondition={null} activeFilters={["driver_name", ]} filterQueryConditions={null} showCreateBtn={true} />
            </Container>
          </div>
        </React.Fragment>
      }
    </>
  )
}

RentalDrivers.propTypes = {}
export default withRouter(RentalDrivers)
